// ru / shared / common namespace. Keys follow `<scope>.<domain>.<key>` naming
// from docs/handoff/_extracts/02-shared-packages-aux.md §2. The flat-key style
// matches the lookup algorithm in i18n.ts (split once on first dot to pick
// the namespace, then flat key inside).
import type { Namespace } from '../../../types.js';

export const common: Namespace = {
  'common.actions.save': 'Сохранить',
  'common.actions.cancel': 'Отменить',
  'common.actions.create': 'Создать',
  'common.actions.delete': 'Удалить',
  'common.actions.confirm': 'Подтвердить',
  'common.labels.loading': 'Загрузка…',
  'common.labels.empty': 'Ничего не найдено',
  'common.labels.search': 'Поиск',
  'common.greeting': 'Привет, {name}!',
};
